// extracted by mini-css-extract-plugin
module.exports = {"textIsBold":"styles_textIsBold___9JAZ","textLink":"styles_textLink__N0yli","containerTotalBasicCostModal":"styles_containerTotalBasicCostModal__h_vuN"};